/**
 * Constants for IIIF Viewer Application
 *
 * This file centralizes all configuration values, magic strings, and constants
 * used throughout the IIIF viewer components. This approach improves maintainability
 * and reduces the risk of typos in string literals.
 */

/**
 * Application View States
 *
 * Defines the three primary states of the IIIF viewer:
 * - PREVIEW: Shows thumbnail with overlay controls
 * - MODAL: Full viewer in overlay mode with close button
 * - FULLSCREEN: Browser fullscreen mode
 */
export const VIEW_STATES = {
    /** Initial state showing thumbnail preview */
    PREVIEW: "preview",
    /** Modal overlay state with viewer controls */
    MODAL: "modal",
    /** Browser fullscreen viewing state */
    FULLSCREEN: "fullscreen",
};

/**
 * CSS Class Names
 *
 * Centralized CSS class constants to prevent typos and improve
 * maintainability when styling needs to change.
 */
export const CSS_CLASSES = {
    /** Applied to parent iframe body during modal state */
    IFRAME_PARTIAL_FULLSCREEN: "iframe-partial-fullscreen",
    /** Applied to iframe element during modal state */
    IIIF_VIEWER_MODAL: "iiif-viewer-modal",
};

/**
 * DOM Element Selectors
 *
 * CSS selectors used for DOM queries throughout the application.
 * Centralizing these makes it easier to update if DOM structure changes.
 */
export const DOM_SELECTORS = {
    /** Navigation element within the Glycerine viewer */
    ANNO_GALLERY_NAV: ".anno-gallery-nav",
    /** Target element for teleporting close button */
    ABSOLUTE_DIV: "div.absolute",
};

/**
 * View Type Configurations
 *
 * Different viewing modes that affect layout and behavior.
 * Currently supports portrait orientation for specific content types.
 */
export const VIEW_TYPES = {
    /** Portrait orientation for vertical content */
    PORTRET: "portret",
};

/**
 * Debug Configuration
 *
 * Controls debug logging and development features.
 * Should be set to false in production builds.
 */
export const DEBUG = false;
